import { render, staticRenderFns } from "./MovimentacaoTable.vue?vue&type=template&id=2dadb566&scoped=true"
import script from "./MovimentacaoTable.vue?vue&type=script&lang=js"
export * from "./MovimentacaoTable.vue?vue&type=script&lang=js"
import style0 from "./MovimentacaoTable.vue?vue&type=style&index=0&id=2dadb566&prod&lang=scss"
import style1 from "./MovimentacaoTable.vue?vue&type=style&index=1&id=2dadb566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dadb566",
  null
  
)

export default component.exports